import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import deviceInfo from 'APP/packages/deviceInfo';

export const hasMicrophone = async (): Promise<boolean> => {
  const { hasMicrophone } = await deviceInfo.getMediaDevices();

  if (!hasMicrophone) {
    Tasks.app.showAlert(t('calls_no_microphone_connected'));

    return false;
  }

  return true;
};
